import '../styles/ProductsWithChart.scss'

const PipeTube = () => {
    return (
        <div className='container'>
            <h1>Extruded Pipe and Tube</h1>
            <h3>USED IN CHEMICAL PLANTS, NUCLEAR, HYDRO AND PLATING APPLICATIONS</h3>
            <p>Produced in our hydraulic extruder in long lengths, 8 feet is our standard length. We can produce pipe, sleeving and tubing in a variety of diameters, wall thicknesses and weights.</p>
            <p>Below are our standard sizes. We can also do custom sizes upon request.</p>
            <table className='main-table'>
                <tr>
                    <th>INSIDE DIAMETER</th>
                    <th>WALL THICKNESS</th>
                    <th>OUTSIDE DIAMETER</th>
                    <th>WEIGHT (lbs/ft)</th>
                </tr>
                <tr>
                    <td className='first-col' rowSpan={'3'}>¾"</td>
                    <td>1/8"</td>
                    <td>​1"</td>
                    <td>​​1.69</td>
                </tr>
                <tr><td>3/16"</td>
                    <td>1 1/8"</td>
                    <td>2.72</td>
                </tr>
                <tr className='even-row'>
                    <td>1/4"</td>
                    <td>1 1/4"</td>
                    <td>3.87</td>
                </tr>
                <tr>
                    <td className='first-col' rowSpan={'3'}>1"</td>
                    <td>1/8"</td>
                    <td>1 1/4"</td>
                    <td>2.17</td>
                </tr>
                <tr>
                    <td>3/16"</td>
                    <td>1 3/8"</td>
                    <td>3.44</td>
                </tr>
                <tr className='even-row'>
                    <td>1/4"</td>
                    <td>1 1/2"</td>
                    <td>4.83</td>
                </tr>
                <tr>
                    <td className='first-col' rowSpan={'3'}>1 ¼"</td>
                    <td>1/8"</td>
                    <td> 1 1/2"</td>
                    <td>2.66</td>
                </tr>
                <tr>
                    <td>3/16"</td>
                    <td>1 5/8"</td>
                    <td>4.17</td>
                </tr>
                <tr className='even-row'>
                    <td>1/4"</td>
                    <td>1 3/4"</td>
                    <td>5.8</td>
                </tr>
                <tr>
                    <td className='first-col' rowSpan={'3'}>1 ½"</td>
                    <td>1/8"</td>
                    <td>1 3/4"</td>
                    <td>3.14</td>
                </tr>
                <tr>
                    <td>3/16"</td>
                    <td>1 7/8"</td>
                    <td>4.89</td>
                </tr>
                <tr className='even-row'>
                    <td>1/4"</td>
                    <td>2"</td>
                    <td>6.77</td>
                </tr>
                <tr>
                    <td className='first-col' rowSpan={'3'}>1 ¾"</td>
                    <td>1/8"</td>
                    <td>2"</td>
                    <td>3.62</td>
                </tr>
                <tr>
                    <td>3/16"</td>
                    <td>2 1/8"</td>
                    <td>5.62</td>
                </tr>
                <tr className='even-row'>
                    <td>1/4"</td>
                    <td>2 1/4"</td>
                    <td>7.73</td>
                </tr>
                <tr>
                    <td className='first-col' rowSpan={'3'}>2"</td>
                    <td>1/8"</td>
                    <td>2"</td>
                    <td>4.11</td>
                </tr>
                <tr>
                    <td>3/16"</td>
                    <td>2 3/8"</td>
                    <td>6.34</td>
                </tr>
                <tr className='even-row'>
                    <td>1/4"</td>
                    <td>2 1/2"</td>
                    <td>8.7</td>
                </tr>
                <tr>
                    <td className='first-col' rowSpan={'3'}>2 ½"</td>
                    <td>1/8"</td>
                    <td>2 3/4"</td>
                    <td>5.07</td>
                </tr>
                <tr>
                    <td>3/16"</td>
                    <td>2 7/8"</td>
                    <td>7.79</td>
                </tr>
                <tr className='even-row'>
                    <td>1/4"</td>
                    <td>3"</td>
                    <td>10.63</td>
                </tr>
                <tr>
                    <td className='first-col' rowSpan={'3'}>3"</td>
                    <td>1/8"</td>
                    <td>3 1/4"</td>
                    <td>6.04</td>
                </tr>
                <tr>
                    <td>3/16"</td>
                    <td>3 3/8"</td>
                    <td>9.24</td>
                </tr>
                <tr className='even-row'>
                    <td>1/4"</td>
                    <td>3 1/2"</td>
                    <td>12.56</td>
                </tr>
                <tr>
                    <td className='first-col' rowSpan={'3'}>3 ½"</td>
                    <td>1/8"</td>
                    <td>3 3/4"</td>
                    <td>7.01</td>
                </tr>
                <tr><td>3/16"</td>
                    <td>3 7/8"</td>
                    <td>10.69</td>
                </tr>
                <tr className='even-row'>
                    <td>1/4"</td>
                    <td>4"</td>
                    <td>14.5</td>
                </tr>
                <tr><td className='first-col' rowSpan={'3'}>4"</td>
                    <td>1/8"</td>
                    <td>4 1/4"</td>
                    <td>7.97</td>
                </tr>
                <tr>
                    <td>3/16"</td>
                    <td>4 3/8"</td>
                    <td>12.14</td>
                </tr>
                <tr className='even-row'>
                    <td>1/4"</td>
                    <td>4 1/2"</td>
                    <td>16.43</td>
                </tr>
                <tr>
                    <td className='first-col' rowSpan={'3'}>4 ½"</td>
                    <td>1/8"</td>
                    <td>4 3/4"</td>
                    <td>8.94</td>
                </tr>
                <tr>
                    <td>3/16"</td>
                    <td>4 7/8"</td>
                    <td>13.59</td>
                </tr>
                <tr className='even-row'>
                    <td>1/4"</td>
                    <td>5"</td>
                    <td>18.36</td>
                </tr>
                <tr>
                    <td className='first-col' rowSpan={'3'}>5"</td>
                    <td>1/8"</td>
                    <td>5 1/4"</td>
                    <td>9.91</td>
                </tr>
                <tr>
                    <td>3/16"</td>
                    <td>5 3/8"</td>
                    <td>15.04</td>
                </tr>
                <tr className='even-row'>
                    <td>1/4"</td>
                    <td>5 1/2"</td>
                    <td>20.3</td>
                </tr>
                <tr>
                    <td className='first-col' rowSpan={'3'}>6"</td>
                    <td>1/8"</td>
                    <td>6 1/4"</td>
                    <td>11.84</td>
                </tr>
                <tr>
                    <td>3/16"</td>
                    <td>6 3/8"</td>
                    <td>17.94</td>
                </tr>
                <tr className='even-row'>
                    <td>1/4"</td>
                    <td>6 1/2"</td>
                    <td>24.16</td>
                </tr>
                <tr><td className='first-col' rowSpan={'3'}>7"</td>
                    <td>1/8"</td>
                    <td>7 1/4"</td>
                    <td>13.77</td>
                </tr>
                <tr>
                    <td>3/16"</td>
                    <td>7 1/8"</td>
                    <td>20.84</td>
                </tr>
                <tr className='even-row'>
                    <td>1/4"</td>
                    <td>7 1/4"</td>
                    <td>28.03</td>
                </tr>
                <tr><td className='first-col' rowSpan={'3'}>8"</td>
                    <td>1/8"</td>
                    <td>8 1/4"</td>
                    <td>15.71</td>
                </tr>
                <tr>
                    <td>3/16"</td>
                    <td>8 3/8"</td>
                    <td>23.74</td>
                </tr>
                <tr className='even-row'>
                    <td>1/4"</td>
                    <td>8 1/2"</td>
                    <td>31.89</td>
                </tr>
                <tr>
                    <td className='first-col' rowSpan={'3'}>10"</td>
                    <td>1/8"</td>
                    <td>10 1/4"</td>
                    <td>19.57</td>
                </tr>
                <tr><td>3/16"</td>
                    <td>10 3/8"</td>
                    <td>29.54</td>
                </tr>
                <tr><td>1/4"</td>
                    <td>10 1/2"</td>
                    <td>39.63</td>
                </tr>
            </table>
        </div>
    );

};

export default PipeTube;